<template>
  <div class="contact">
    <nav-headers />
    <div class="contents">
      <div class="in-banner">
        <div class="p-nav">
          <div class="p-title">
            <div class="p-1">CONTACT</div>
            <div class="p-2">Home / CONTACT</div>
          </div>
        </div>
        <img src="../assets/img/ny-07-CONTACT.jpg" width="100%" height="auto" />
      </div>
      <div class="pageBox ">
        <div class="titles">CONTACT INFORMATION</div>
        <div class="pageContent">
          <div class="le">
            <div class="p-t">Feel free to ask questions or share your comments with us.</div>
            <div class="p-2-t">You can also reach out to us by phone or email.</div>
            <div class="p-s">
              <div class="left" style="">
                <img  src="../assets/img/mobile.jpg" width="90%" height="auto"></img>
                <div style="width: 80%;overflow: hidden;text-align: center;color: #fff;margin-top: 20px;">Mobile</div>
              </div>
              <div class="right" style="" @click="phones()">
                <div class="call-us">
                  <div class="phones_number" style="">+86-135-8600-1336</div>
                  <div style="color: #fff;margin-top: 15px;font-size: 15px;">Call me now !</div>
                </div>
              </div>
            </div>
          </div>
          <div class="ri">
            <div class="title">
              Are you ready to
              cooperate with us.
            </div>
            <div class="text">Please fill in the following information carefully!</div>
            <div class="centers">
              <el-form :model="form" 
                label-width="0px" 
                ref="loginForms"
                autocomplete="on"
                label-position="left"
                :rules="rules"
            >
                <el-form-item>
                  <el-input v-model="form.name" style="width: 49%;float: left;background: #fff;border-radius: 0px;" placeholder="Name"></el-input>
                  <el-input v-model="form.email" style="width: 49%;float: right;background: #fff;border-radius: 0px;" placeholder="Email"></el-input>
                </el-form-item>
                <el-form-item style="margin-top: 10px;">
                  <el-input type="textarea" :rows="4" v-model="form.description" placeholder="Message"></el-input>
                </el-form-item>
                <el-form-item>
                  <div class="btn_send" 
                  @click.stop.prevent="Messageadds()">
                    <span class="send_icon_text">SEND</span>
                  </div>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
        <div class="link-list">
          <div class="link-items" style="margin-left: 0%;">
            <div class="link-address"></div>

            <div> Yiwu </div>
            <div>International Expo Center, </div>
            <div>Zhejiang, China </div>
            <div style="color: #676767;font-size: 15px;margin-top: 15px;">Add </div>
          </div>
          <div class="link-items">
            <div class="link-phone"></div>
            <div style="line-break: anywhere;">daivd@fullgemtools.com</div>
            <div style="color: #676767;font-size: 15px;margin-top: 15px;">Email </div>
          </div>
          <div class="link-items">
            <div class="link-tel"></div>
            <div>+86-138-5866-3169</div>
            <div style="color: #676767;font-size: 15px;margin-top: 15px;">Whatsapp </div>
          </div>
        </div>
      </div>
    </div>
    <nav-footer />
  </div>
</template>
<script>
//import NavHeaders from "@/components/NavHeaders.vue";
import NavFooter from "@/components/NavFooter.vue";
export default {
  name: 'contact',
  data() {
    return {
      form: {
        name: '',
        email:'',
        description: '',
      },
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],

      },

      id: this.$route.params.id,
      Factorys: [],
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      total: 0,

      showSlide: '', //控制动画效果
      list: [
        {}, {}, {}, {}, {}, {}, {}, {}, {}
      ],
      product: [

      ],

    };
  },
  components: {
    NavHeaders: () => import('@/components/NavHeaders.vue'),
    NavFooter,
  },
  mounted() {
    this.$nextTick(() => {
      this.handleAnimate()//初始化第一次加载时在视口内就执行动画
      addEventListener('scroll', this.handleAnimate);
    })
  },

  destroyed() {
    removeEventListener('scroll', this.handleAnimate);
  },
  created() {
    document.documentElement.scrollTop = "0px";
    setTimeout(this.handleAnimate, 1000);
  },
  methods: {
    Messageadds() {
      let self = this;
      if(!self.form.name){
        self.$layer.msg('Please Name');
        return
      }
      if(!self.form.email){
        self.$layer.msg('Please email');
        return
      }
      if(!self.form.description){
        self.$layer.msg('Please Message');
        return
      }
      this.$api.mall
        .Messageadd({
          name: self.form.name,
          description: self.form.description,
          email: self.form.email,
        })
        .then((res) => {
          if (res.code == 1) {
            self.$message.success("success");
            self.reset();
          } else {
            self.$message.error(res.msg);
          }
        });
    },
    phones(){
      window.location.href = `tel://+8613586001336`;
    },
    reset(){
      let self = this;
      self.form.name=''
      self.form.description=''
      self.form.email=''
    },
    handleAnimate() {
      let top = pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      let vh = document.documentElement.clientHeight;
      let dom = document.querySelectorAll(".animate");
      [].slice.call(dom).forEach(v => {
        if (top + vh > v.offsetTop) {
          var delay = v.dataset.delay;
          if (delay) {
            setTimeout(() => {
              v.style.opacity = 1;
              v.classList.add(v.dataset.ani)
            }, delay)
          } else {
            v.style.opacity = 1;
            v.classList.add(v.dataset.ani)
          }
        } else {
          v.classList.remove(v.dataset.ani)
          v.style.opacity = 0;
        }
      })
    },
    buy(val) {
      //let id = this.$route.params.id;
      //this.$router.push(`/detail/${val}`);
    },
  }
};
</script>
<style lang="scss">

@media screen and (min-width: 0px) and (max-width:1024px) {
  .contact {
  width: 100%;
  overflow: hidden;
  margin: 0px auto;

  //animate classs
  .animate {
    opacity: 0;
  }

  .fadeInUpBig {
    animation: fadeInUpBig 1s;
  }

  .rollIn {
    animation: rollIn 1s;
  }

  .slideInRight {
    animation: slideInRight 1s;
  }

  .bounceInLeft {
    animation: bounceInLeft 2s ease-in;
  }

  .bounceInRight {
    animation: bounceInRight 2s ease-in;
  }

  .el-pages {
    text-align: center;
    width: 100%;
    margin: 85px auto;
    overflow: hidden;
  }

  .pageBox {
    width: 100%;
    overflow: hidden;
    margin: 0px auto;
    background: #fff;
    padding: 0px;
    box-sizing: border-box;

    .link-list {
      width: 100%;
      margin: 0px auto;
      overflow: hidden;
      box-sizing: border-box;
      padding: 0px;
      .link-items {
        width: 90%;
        overflow: hidden;
        box-sizing: border-box;
        margin-left: 0px !important;
        margin:20px auto !important;
        min-height: 137px;
        padding-top: 30px;
        padding-left:20px;
        padding-bottom:30px;
        font-size: 16px;
        font-weight: 600;
        position: relative;
        color: #1c1c1c;
        background: #ededed;
        cursor: pointer;
        .link-tel{
          position: absolute;
          width: 90px;
          height: 90px;
          top: 0px;
          right: 0px;
          background:url(../assets/img/WhatApp.png) no-repeat center #02999d;
          background-size: 36px;
        }
        .link-phone{
          position: absolute;
          width: 90px;
          height: 90px;
          top: 0px;
          right: 0px;
          background:url(../assets/img/ic_eamil.png) no-repeat center #02999d;
          background-size: 36px;
        }
        .link-address{
          position: absolute;
          width: 90px;
          height: 90px;
          top: 0px;
          right: 0px;
          background:url(../assets/img/address.png) no-repeat center #02999d;
          background-size: 36px;

        }
      }
    }

    .pageContent {
      width: 100%;
      overflow: hidden;
      margin: 0px auto;
      background: #fff;
      box-sizing: border-box;
      padding: 0px;


      .ri {
        width: 90%;
        background:#ededed;
        overflow: hidden;
        box-sizing:border-box;
        padding: 18px;
        margin: 0px auto;
        .centers{
          width: 100%;
        }

        .btn_send {
          color: #02999d;
          width: 160px;
          cursor: pointer;
          height: 50px;
          line-height: 50px;
          text-align: center;
          background: none;
          border: 3px solid #02999d;

          .send_icon_text {
            width: 50px;
            font-size: 18px;
            line-height: 50px;
            font-family:'Rany-Bold';
            font-weight: 600;
            margin: 0px auto;
            display: block;
            background: url(../assets/img/send.png) no-repeat right;
            background-size: 22px;
            padding-right: 26px;
            text-align: center;
          }
        }

        .text {
          width: 100%;
          overflow: hidden;
          color: #676767;
          margin-top: 12.5px;
          margin-bottom: 25px;
        }

        .title {
          color: #252525;
          font-weight: 600;
          width: 100%;
          font-size: 32px;
          overflow: hidden;
        }

      }

      .le {
        width: 90%;
        overflow: hidden;
        margin: 40px auto auto auto;
        box-sizing:border-box;
        padding: 18px;
        background: url(../assets/img/123.png) no-repeat center #252525;
        background-size: 100%;

        .p-s {
          width: 100%;
          overflow: hidden;
          margin: 0px auto;
          box-sizing: border-box;
          .left{
            width: 180px;
            text-align: left;
            overflow: hidden;
          }
          .right{
            width:100%;
            box-sizing: border-box;
            padding: 0px;
            margin: 15px auto;
            overflow: hidden;
         
          }

          .call-us {
            width: 100%;
            font-size: 24px !important;
            padding: 35px 0px 35px 12.5px;
            overflow: hidden;
            border-top: 1px solid #676767;
            border-bottom: 1px solid #676767;
            .phones_number{
              font-size: 32px;color: #fff;font-weight: 600;
            }
          }
        }

        .p-2-t {
          overflow: hidden;
          width: 100%;
          margin: 15px auto;
          color: #676767;
        }

        .p-t {
          width: 100%;
          overflow: hidden;
          color: #fff;
          font-size: 24px;
          font-weight: 600;
        }
      }

    }

    .titles {
      display: none;
      width: 100%;
      overflow: hidden;
      margin: 0px auto;
      text-align: center;
      font-size: 38px;
      padding-top: 20px;
      padding-bottom: 20px;
      color: #1c1c1c;
      font-weight: 600;
    }
  }

  .v-enter {
    opacity: 0;
    transform: translateY(150px);
  }

  .v-enter-active {
    transition: all 1s ease;
  }

  .in-banner {
    width: 100%;
    overflow: hidden;
    margin: 0px auto;
    padding: 0px;
    box-sizing: border-box;
    position: relative;
    color: #fff;
    img{
      width: 150%;
      height: auto;
    }

    .p-nav {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0px;
      text-align: center;
      display: flex;
      justify-content: center;
      /* 水平居中 */
      align-items: center;
      /* 垂直居中 */
      top: 0px;

      .p-title {
        width: 100%;
        margin: 0px auto;
        box-sizing: border-box;
        padding: 0px;
        text-transform: uppercase;

        text-align: center;
        overflow: hidden;

        .p-1 {
          font-size: 40px;
          color: #fff;
          font-weight: 600;
        }

        .p-2 {
          color: #0299a5;
          font-size: 16px;
          margin-top: 8px;
          line-height: 28px;
        }
      }
    }
  }

  .contents {
    width: 100%;
    min-width: 0px;
    overflow: hidden;
    margin: 0px auto;
    padding-top: 61px;
   }
  }

}


@media screen and (min-width: 1024px) and (max-width:1600px) {
  .contact {
  width: 100%;
  overflow: hidden;
  margin: 0px auto;

  //animate classs
  .animate {
    opacity: 0;
  }

  .fadeInUpBig {
    animation: fadeInUpBig 1s;
  }

  .rollIn {
    animation: rollIn 1s;
  }

  .slideInRight {
    animation: slideInRight 1s;
  }

  .bounceInLeft {
    animation: bounceInLeft 2s ease-in;
  }

  .bounceInRight {
    animation: bounceInRight 2s ease-in;
  }

  .el-pages {
    text-align: center;
    width: 100%;
    margin: 85px auto;
    overflow: hidden;
  }

  .pageBox {
    width: 100%;
    overflow: hidden;
    margin: 0px auto;
    background: #fff;
    padding: 0px;
    box-sizing: border-box;

    .link-list {

      width: 1200px;
      margin: 0px auto;
      overflow: hidden;
      margin-top: 50px;
      margin-bottom: 80px;
      box-sizing: border-box;
      padding: 0px;

      .link-items {
        width: 31.33%;
        overflow: hidden;
        margin-left: 3%;
        float: left;
        box-sizing: border-box;
        min-height: 240px;
        font-size: 24px;
        font-weight: 600;
        padding-top: 50px;
        position: relative;
        padding-right: 110px;
        color: #1c1c1c;
        padding-left: 90px;
        padding-bottom: 60px;
        background: #ededed;
        cursor: pointer;
        .link-tel{
          position: absolute;
          width: 90px;
          height: 90px;
          top: 0px;
          right: 0px;
          background:url(../assets/img/WhatApp.png) no-repeat center #02999d;
          background-size: 36px;
        }
        .link-phone{
          position: absolute;
          width: 90px;
          height: 90px;
          top: 0px;
          right: 0px;
          background:url(../assets/img/ic_eamil.png) no-repeat center #02999d;
          background-size: 36px;
        }
        .link-address{
          position: absolute;
          width: 90px;
          height: 90px;
          top: 0px;
          right: 0px;
          background:url(../assets/img/address.png) no-repeat center #02999d;
          background-size: 36px;

        }
      }
    }

    .pageContent {
      width: 1200px;
      overflow: hidden;
      margin: 0px auto;
      background: #ededed;
      box-sizing: border-box;
      padding: 0px;


      .ri {
        width: calc(50% - 90px);
        padding-left: 90px;
        overflow: hidden;
        margin: 0px auto;
        .centers{
          width: 80%;
        }

        .btn_send {
          color: #02999d;
          width: 160px;
          cursor: pointer;
          height: 50px;
          line-height: 50px;
          text-align: center;
          background: none;
          border: 3px solid #02999d;

          .send_icon_text {
            width: 50px;
            font-size: 18px;
            font-weight: 600;
            margin: 0px auto;
            display: block;
            background: url(../assets/img/send.png) no-repeat right;
            background-size: 22px;
            padding-right: 26px;
            text-align: center;
          }
        }

        .text {
          width: 100%;
          overflow: hidden;
          color: #676767;
          margin-top: 15px;
          margin-bottom: 35px;
        }

        .title {
          padding-top: 80px;
          font-size: 48px;
          color: #252525;
          font-weight: 600;
          width: 440px;
          overflow: hidden;
          line-height: 48px;
        }

      }

      .le {
        width: 50%;
        float: left;
        box-sizing: border-box;
        overflow: hidden;
        margin: 0px auto;
        padding: 0px;
        background: url(../assets/img/123.png) no-repeat center;
        background-size: 100% 100%;

        .p-s {
          width: 100%;
          overflow: hidden;
          margin: 0px auto;
          padding-top: 20px;
          padding-bottom: 40px;
          padding-left: 80px;
          box-sizing: border-box;
          .left{
            float: left;width: 185px;text-align: left;
          }
          .right{
            float: right;width: calc(100% - 185px );overflow: hidden;
        
          }

          .call-us {
            width: 80%;
            margin-left: 50px;
            box-sizing: border-box;
            overflow: hidden;
            padding-top: 50px;
            padding-bottom: 60px;
            border-top: 1px solid #676767;
            border-bottom: 1px solid #676767;
            .phones_number{
              font-size: 42px;color: #fff;font-weight: 600;
            }
          }
        }

        .p-2-t {
          padding-left: 80px;
          padding-top: 30px;
          overflow: hidden;
          width: 100%;
          color: #676767;
        }

        .p-t {
          padding-left: 80px;
          padding-top: 80px;
          padding-right: 80px;
          width: 100%;
          overflow: hidden;
          color: #fff;
          box-sizing: border-box;
          font-size: 48px;
          font-weight: 600;
        }
      }

    }

    .titles {
      width: 1200px;
      overflow: hidden;
      margin: 0px auto;
      text-align: center;
      font-size: 35px;
      padding-top: 80px;
      padding-bottom: 80px;
      color: #1c1c1c;
      font-weight: 600;
    }
  }

  .v-enter {
    opacity: 0;
    transform: translateY(150px);
  }

  .v-enter-active {
    transition: all 1s ease;
  }

  .in-banner {
    width: 100%;
    overflow: hidden;
    margin: 0px auto;
    padding: 0px;
    box-sizing: border-box;
    position: relative;
    color: #fff;

    .p-nav {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0px;
      text-align: center;
      display: flex;
      justify-content: center;
      /* 水平居中 */
      align-items: center;
      /* 垂直居中 */
      top: 0px;

      .p-title {
        width: 188px;
        margin: 0px auto;
        box-sizing: border-box;
        padding: 0px;
        text-align: center;
        text-transform: uppercase;
        overflow: hidden;

        .p-1 {
          font-size: 40px;
          color: #fff;
          font-weight: 600;
        }

        .p-2 {
          color: #0299a5;
          font-size: 16px;
          margin-top: 8px;
          line-height: 28px;
        }
      }
    }
  }

  .contents {
    width: 100%;
    min-width: 1350px;
    overflow: hidden;
    margin: 0px auto;
    padding-top: 75px;
   }
  }

}

@media screen and (min-width: 1601px) and (max-width:8000px) {
.contact {
  width: 100%;
  overflow: hidden;
  margin: 0px auto;

  //animate classs
  .animate {
    opacity: 0;
  }

  .fadeInUpBig {
    animation: fadeInUpBig 1s;
  }

  .rollIn {
    animation: rollIn 1s;
  }

  .slideInRight {
    animation: slideInRight 1s;
  }

  .bounceInLeft {
    animation: bounceInLeft 2s ease-in;
  }

  .bounceInRight {
    animation: bounceInRight 2s ease-in;
  }

  .el-pages {
    text-align: center;
    width: 100%;
    margin: 85px auto;
    overflow: hidden;
  }

  .pageBox {
    width: 100%;
    overflow: hidden;
    margin: 0px auto;
    background: #fff;
    padding: 0px;
    box-sizing: border-box;

    .link-list {

      width: 1600px;
      margin: 0px auto;
      overflow: hidden;
      margin-top: 50px;
      margin-bottom: 80px;
      box-sizing: border-box;
      padding: 0px;

      .link-items {
        width: 31.33%;
        overflow: hidden;
        margin-left: 3%;
        float: left;
        box-sizing: border-box;
        min-height: 215px;
        font-size: 24px;
        font-weight: 600;
        padding-top: 50px;
        position: relative;
        padding-right: 110px;
        color: #1c1c1c;
        padding-left: 90px;
        padding-bottom: 60px;
        background: #ededed;
        cursor: pointer;
        .link-tel{
          position: absolute;
          width: 90px;
          height: 90px;
          top: 0px;
          right: 0px;
          background:url(../assets/img/WhatApp.png) no-repeat center #02999d;
          background-size: 36px;
        }
        .link-phone{
          position: absolute;
          width: 90px;
          height: 90px;
          top: 0px;
          right: 0px;
          background:url(../assets/img/ic_eamil.png) no-repeat center #02999d;
          background-size: 36px;
        }
        .link-address{
          position: absolute;
          width: 90px;
          height: 90px;
          top: 0px;
          right: 0px;
          background:url(../assets/img/address.png) no-repeat center #02999d;
          background-size: 36px;

        }
      }
    }

    .pageContent {
      width: 1600px;
      overflow: hidden;
      margin: 0px auto;
      background: #ededed;
      box-sizing: border-box;
      padding: 0px;


      .ri {
        width: calc(50% - 90px);
        padding-left: 90px;
        overflow: hidden;
        margin: 0px auto;
        .centers{
          width: 80%;
        }

        .btn_send {
          color: #02999d;
          width: 160px;
          cursor: pointer;
          height: 50px;
          line-height: 50px;
          text-align: center;
          background: none;
          border: 3px solid #02999d;

          .send_icon_text {
            width: 50px;
            font-size: 18px;
            font-weight: 600;
            margin: 0px auto;
            display: block;
            background: url(../assets/img/send.png) no-repeat right;
            background-size: 22px;
            padding-right: 26px;
            text-align: center;
          }
        }

        .text {
          width: 100%;
          overflow: hidden;
          color: #676767;
          margin-top: 15px;
          margin-bottom: 35px;
        }

        .title {
          padding-top: 80px;
          font-size: 48px;
          color: #252525;
          font-weight: 600;
          width: 440px;
          overflow: hidden;
          line-height: 48px;
        }

      }

      .le {
        width: 50%;
        float: left;
        box-sizing: border-box;
        overflow: hidden;
        margin: 0px auto;
        padding: 0px;
        background: url(../assets/img/123.png) no-repeat center;
        background-size: 100%;

        .p-s {
          width: 100%;
          overflow: hidden;
          margin: 0px auto;
          padding-top: 20px;
          padding-bottom: 40px;
          padding-left: 80px;
          box-sizing: border-box;
          .left{
            float: left;width: 185px;text-align: left;
          }
          .right{
            float: right;width: calc(100% - 185px );overflow: hidden;
        
          }

          .call-us {
            width: 80%;
            margin-left: 50px;
            box-sizing: border-box;
            overflow: hidden;
            padding-top: 50px;
            padding-bottom: 60px;
            border-top: 1px solid #676767;
            border-bottom: 1px solid #676767;
            .phones_number{
              font-size: 42px;color: #fff;font-weight: 600;
            }
          }
        }

        .p-2-t {
          padding-left: 80px;
          padding-top: 30px;
          overflow: hidden;
          width: 100%;
          color: #676767;
        }

        .p-t {
          padding-left: 80px;
          padding-top: 80px;
          padding-right: 80px;
          width: 100%;
          overflow: hidden;
          color: #fff;
          box-sizing: border-box;
          font-size: 48px;
          font-weight: 600;
        }
      }

    }

    .titles {
      width: 1600px;
      overflow: hidden;
      margin: 0px auto;
      text-align: center;
      font-size: 35px;
      padding-top: 80px;
      padding-bottom: 80px;
      color: #1c1c1c;
      font-weight: 600;
    }
  }

  .v-enter {
    opacity: 0;
    transform: translateY(150px);
  }

  .v-enter-active {
    transition: all 1s ease;
  }

  .in-banner {
    width: 100%;
    overflow: hidden;
    margin: 0px auto;
    padding: 0px;
    box-sizing: border-box;
    position: relative;
    color: #fff;

    .p-nav {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0px;
      text-align: center;
      display: flex;
      justify-content: center;
      /* 水平居中 */
      align-items: center;
      /* 垂直居中 */
      top: 0px;

      .p-title {
        width: 188px;
        margin: 0px auto;
        box-sizing: border-box;
        padding: 0px;
        text-align: center;
        text-transform: uppercase;
        overflow: hidden;

        .p-1 {
          font-size: 40px;
          color: #fff;
          font-weight: 600;
        }

        .p-2 {
          color: #0299a5;
          font-size: 16px;
          margin-top: 8px;
          line-height: 28px;
        }
      }
    }
  }

  .contents {
    width: 100%;
    min-width: 1350px;
    overflow: hidden;
    margin: 0px auto;
    padding-top: 75px;
   }
  }
}
</style>